import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  FormData: FormGroup;
  modalReference: any;
  constructor(private modalService: NgbModal, private builder: FormBuilder) { }

  ngOnInit(): void {
    this.FormData = this.builder.group({
      user_name: new FormControl('', [Validators.required]),
      user_email: new FormControl('', [Validators.compose([Validators.required, Validators.email])]),
      user_number: new FormControl('',[Validators.compose([ Validators.required,Validators.pattern("^[0-9]*$"),Validators.minLength(10), Validators.maxLength(10)])]),
      user_subject: new FormControl('', [Validators.required]),
      user_message: new FormControl('', [Validators.required])
      })
  }
  openContact(content) { //open(content,product) for product
    // this.modalTitle = product.title;
    // this.modaltDescription = product.description;
    this.modalReference = this.modalService.open(content);
    // this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  public sendEmail(e: Event) {
    e.preventDefault();
    emailjs.sendForm('service_9q6nx6t', 'template_j9pzm3q', e.target as HTMLFormElement, 'user_Nta3Via2yHAqITmxyMgjm')
      .then((result: EmailJSResponseStatus) => {
        // console.log(result.text);
        this.FormData.reset();
        this.modalReference.close();
      }, (error) => {
        // console.log(error.text);
      });
  }

}
